import { reimRequest } from '@services'
import { Notify } from 'vant'
import { deepCopy } from '@utils/basicUtil'
export default {
  namespaced: true,
  state: {
    reimList: [],
    reimInfo: {},
    errorList: [],
    examineInfo: {},
    total: ''
  },
  mutations: {
    setReimList (state, reimList) {
      state.reimList = reimList
    },
    setReimInfo (state, reimInfo) {
      state.reimInfo = reimInfo
    },
    setErrorList (state, errorList) {
      state.errorList = errorList
    },
    setExamineInfo (state, examineInfo) {
      state.examineInfo = examineInfo
    },
    setTotal (state, total) {
      state.total = total
    }
  },
  actions: {
    async getExamineInfo ({ commit }, reimNo) {
      const res = await reimRequest.reim.getExamineInfo({
        bizDataId: reimNo
      })
      if (res.success) {
        const examineInfo = deepCopy(res.result) || {}
        if (examineInfo && examineInfo.nodeList) {
          examineInfo.nodeList.forEach(item => {
            item.approvalRoleId = JSON.parse(item.approvalRoleId)
            item.approverId = JSON.parse(item.approverId)
          })
        }
        await commit('setExamineInfo', examineInfo)
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    },
    async getReimList ({ commit }, queyr) {
      const res = await reimRequest.reim.getReimList(queyr)
      console.log(res)
      if (res.success) {
        await commit('setReimList', res.result.records)
        await commit('setTotal', res.result.total)
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    },
    async getReimListPage ({ commit, state }, queyr) {
      let newReimList = state.reimList
      const res = await reimRequest.reim.getReimList(queyr)
      console.log(res)
      if (res.success) {
        let list = newReimList.concat(res.result.records)
        await commit('setReimList', list)
        await commit('setTotal', res.result.total)
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    },
    async getReimInfo ({ commit }, reimNo) {
      const res = await reimRequest.reim.getReimInfo({ reimNo })
      if (res.success) {
        await commit('setReimInfo', res.result)
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    },
    async saveOrUpdate ({ commit }, query) {
      const res = await reimRequest.reim.addOrEditReim({ ...query })
      if (res.success) {
        return res.success
      } else {
        Notify({ type: 'danger', message: res.message })
        console.log(res)
        await commit('setErrorList', res.result.data || [])
      }
    },
    async delReimById ({ commit }, reimNos) {
      const res = await reimRequest.reim.delReimById({ reimNos })
      if (res.success) {
        Notify({ type: 'success', message: '删除成功' })
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    }
  }
}
